<template>
  <div class="role">
    <div class="left-menus" v-if="adminId == 1">
      <div class="left-list">
        <div :class="enpId == item.id ? 'left-enp-item-active' : 'left-enp-item'" v-for="item in companyList"
          :key="item.id" @click="handleEnp(item.id)">
          <div class="enp-item-name" :title="item.name">{{ item.id }}·{{ item.name }}</div>
        </div>
      </div>
    </div>
    <div class="right-wrap">
      <div class="query-wrap">
        <div class="qjc-flex">
          <el-select v-model="packageVal" class="query-package" @change="handleChangeSelect">
            <el-option v-for="item in packageList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <div class="query-date">
            <div class="query-date-label">{{ $t('table.t11') }}</div>
            <el-date-picker v-model="searchDate" type="daterange" value-format="timestamp" range-separator="~"
              :start-placeholder="$t('table.t12')" :end-placeholder="$t('table.t13')" @change="searchDateChange">
            </el-date-picker>
          </div>
        </div>
        <el-button class="query-btn" @click="handleQuery">{{ $t('table.t39') }}</el-button>
        <el-button class="query-btn" @click="handleRet">{{ $t('table.t40') }}</el-button>
      </div>
      <el-table :data="lists" style="width: 100%" row-key="id"
        :tree-props="{ children: 'haList', hasChildren: 'hasChildren' }" class="list">

        <template slot="empty">
          <div class="empty-wrap">
            <el-image class="empty-img" :src="require('@/assets/images/empty-history.png')"></el-image>
            <div class="empty-text">暂无数据</div>
          </div>
        </template>
        <el-table-column prop="id" :label="$t('table.t1')" min-width="60">

        </el-table-column>
        <el-table-column :label="$t('table.t9')" min-width="60">
          <template slot-scope="scope">
            <span v-if="scope.row.old_id && scope.row.old_id != 0" :class="{ 'c-danger': scope.row.old_id > 0 }">{{
              scope.row.old_id > 0 ? $t('table.t38') : $t('table.t44') }}</span>
            <span v-if="scope.row.old_id == undefined">{{ $t('table.t44') }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="mobile" :label="$t('table.t2')" min-width="160">
          <template slot-scope="scope">
            {{ scope.row.mobile ? scope.row.mobile : '--' }}
          </template>
        </el-table-column>

        <el-table-column prop="goods_name" :label="$t('table.t3')" class-name="package" min-width="160">
          <template slot-scope="scope">
            {{ scope.row.goods_name }}
          </template>
        </el-table-column>

        <el-table-column prop="sex" :label="$t('table.t4')" class-name="sex" min-width="60">
          <template slot-scope="scope">
            {{ scope.row.sex == '1' ? $t('open.t14') : scope.row.sex == '2' ? $t('open.t15') : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="birth" :label="$t('table.t5')" class-name="birth" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.birth ? scope.row.birth : '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="examdate" :label="$t('table.t6')" class-name="examdate" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.examdate ? scope.row.examdate : '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="operator" :label="$t('table.t10')" class-name="operator" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.operator ? scope.row.operator : '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="created_at" :label="$t('table.t15')" class-name="created_at" min-width="180px">
          <template slot-scope="scope">
            <span>{{ scope.row.created_at || '--' }}</span>

          </template>
        </el-table-column>

      </el-table>

      <el-pagination prev-text="上一页" next-text="下一页" layout="total, prev, pager, next,jumper" hide-on-single-page
        :current-page.sync="pager.page" :page-count="pager.pagecount" :page-size="pager.pagesize" :total="pager.count"
        @current-change="pageChange">
      </el-pagination>
    </div>


  </div>
</template>

<script>
import {
  adminRole,
  enterpriseList,
  getHistory,
  mainDataQuery,
  getGoodsList
} from "@/utils/axios"

export default {
  name: 'mainHistory',
  data () {
    return {
      submiting: false, //正在请求
      lists: [],
      mainHeight: (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) -
        60,
      companyList: [],
      pager: {
        count: 0,
        page: 1, // 默认第一页
        pagecount: 0,
        pagesize: 12 //默认一页15条数据
      },
      enpId: '',
      packageList: [],
      packageVal: '',
      searchDate: '', //检索日期
      selectRowData: [], // 存储所选列表行数据
      adminId: ''
    }
  },
  mounted () {
    let adminId = JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo'))
      .issupper : '0'
    this.adminId = adminId
    // 获取企业列表
    if (adminId == 1) {
      enterpriseList({
        act: ''
      }).then((res) => {
        if (res.code == 200) {
          const result = JSON.parse(window.atob(res.data))
          this.companyList = result;

          if (Array.isArray(this.companyList)) {
            this.companyList.unshift({
              id: '0',
              name: '全部'
            })
          }
          this.enpId = "0"
          mainDataQuery({
            corp_id: this.enpId,
            startat: '',
            endat: '',
            goods_id: this.packageVal,
            page: this.pager.page,
            pagesize: this.pager.pagesize
          }).then(res => {
            if (res.code == 200) {
              // 历史记录列表数据
              const dResult = JSON.parse(window.atob(res.data))

              let list = dResult.data;

              for (let i = 0; i < list.length; i++) {
                let obj = list[i].haList.pop()
                list[i].birth = obj.birth
                list[i].sex = obj.sex
                list[i].operator = obj.operator
              }
              this.lists = list
              // 分页
              var pager = dResult.pager;
              for (var key in pager) {
                pager[key] = parseInt(pager[key]);
              }
              this.pager = pager;
            } else {
              this.$myAlert({
                type: 'fail',
                content: res.msg
              });
            }
          });
        } else {
          this.$myAlert({
            type: 'fail',
            title: res.msg
          });
        }
      })
    } else {
      this.getHistoryList()
    }

    this.handleGoodsList()
  },
  methods: {
    handleEnp (id) {
      this.enpId = id
      this.packageVal = ''
      this.searchDate = ''
      this.pager.page = 1
      this.getHistoryList()
    },
    // 查询
    searchDateChange (daterange) {
      this.pager.page = 1
      // this.getHistoryList();
    },
    handleChangeSelect (val) {
      this.pager.page = 1
      // this.getHistoryList();
    },
    handleQuery () {
      this.pager.page = 1
      this.getHistoryList();
    },
    handleRet () {
      this.packageVal = ''
      this.searchDate = ''
      this.pager.page = 1
      this.getHistoryList();
    },
    pageChange (page) {
      this.pager.page = page;
      this.getHistoryList();
    },
    handleGoodsList () {
      getGoodsList().then((res) => {
        if (res.code == 200) {
          let goodsList = JSON.parse(window.atob(res.data))
          let list = []
          goodsList.map((goods) => {
            list.push({
              id: goods.id,
              name: goods.name
            })
          })
          list.unshift({
            id: '',
            name: '全部套餐'
          })
          this.packageList = list
        }
      })
    },
    // 获取列表
    getHistoryList () {
      // page 分页  act 操作类型
      let data = {}
      if (this.adminId) {
        data = {
          corp_id: this.enpId,
          startat: this.searchDate && this.searchDate.length > 0 ? this.searchDate[0] / 1000 : '',
          endat: this.searchDate && this.searchDate.length > 0 ? this.searchDate[1] / 1000 + 86399 : '',
          goods_id: this.packageVal,
          page: this.pager.page,
          pagesize: this.pager.pagesize
        }
      } else {
        data = {
          goods_id: this.packageVal,
          startat: this.searchDate && this.searchDate.length > 0 ? this.searchDate[0] / 1000 : '',
          endat: this.searchDate && this.searchDate.length > 0 ? this.searchDate[1] / 1000 + 86399 : '',
          page: this.pager.page,
          pagesize: this.pager.pagesize
        }
      }
      mainDataQuery(data).then(res => {
        if (res.code == 200) {
          // 历史记录列表数据
          const result = JSON.parse(window.atob(res.data))
          let list = result.data;


          for (let i = 0; i < list.length; i++) {
            let obj = list[i].haList.pop()
            list[i].birth = obj.birth
            list[i].sex = obj.sex
            list[i].operator = obj.operator
          }
          this.lists = list

          // 分页
          var pager = result.pager;
          for (var key in pager) {
            pager[key] = parseInt(pager[key]);
          }
          this.pager = pager;
        } else {
          this.$myAlert({
            type: 'fail',
            content: res.msg
          });
        }
      });
    },
  }
}
</script>

<style scoped>
.right-wrap>>>.el-table th {
  background-color: #F2F4FA;
}

.right-wrap>>>.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 380px;
}

.right-wrap>>>.el-date-editor .el-range-separator {
  color: #DBDDE6;
}
</style>
<style lang="scss" scoped>
.role {
  display: flex;
  // padding: 24px;
  width: 100%;
  height: 100%;
  // border: 12px solid #F2F4FA;

  .left-menus {
    min-width: 170px;
    width: 170px;
    padding: 0 24px 30px;
    border-right: 1px solid #E5E8F5;
    background-color: #ffffff;
    overflow-y: auto;

    .add-action {
      display: flex;
      align-items: center;
      cursor: pointer;

      .add-action-img {
        display: flex;
        align-items: center;
        align-items: center;
        width: 24px;
        height: 24px;
        background-color: #6883FB;
        border-radius: 50%;

        &::after {
          content: "+";
          width: 100%;
          font-size: 20px;
          color: #fff;
          text-align: center;
          margin-bottom: 4px;
        }
      }

      .add-action-text {
        font-size: 14px;
        color: #6883FB;
        margin-left: 8px;
      }
    }

    .left-list {
      padding-top: 20px;
    }

    .left-enp-item {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 12px 0;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #525866;
      cursor: pointer;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &:hover {
        color: #7A92FB;
      }
    }

    .left-enp-item-active {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 12px 0;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 500;
      color: #6883FB;
      cursor: pointer;
    }

    .enp-item-status {
      width: 20px;
      height: 20px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FF5219;
      background-color: #FDE8E2;
      margin-right: 4px;
      padding-top: 1px;
      border-radius: 50%;
      text-align: center;
    }

    .enp-item-name {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .enp-item-status-active {
      width: 20px;
      height: 20px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #6883FB;
      background-color: #DCE3FF;
      margin-right: 4px;
      padding-top: 1px;
      border-radius: 50%;
      text-align: center;
    }
  }

  .right-wrap {
    position: relative;
    height: 100%;
    flex: 1;
    padding: 28px 24px;
    overflow: auto;

    .query-wrap {
      display: flex;
      align-items: center;
      // justify-content: space-between;
      margin-bottom: 16px;

      .query-package {
        width: 226px;
      }
    }

    .c-danger {
      color: #FF4C52;
    }

    .query-date {
      display: flex;
      align-items: center;
      margin-left: 32px;

      .query-date-label {
        margin-right: 10px;
      }
    }

    .query-btn {
      width: 72px;
      height: 36px;
      line-height: 36px;
      font-size: 15px;
      padding: 0;
      margin-left: 16px;
      border: none;
      color: #fff;
    }

    .el-button:active {
      background-color: #5B73DC;
    }
  }

  .foot-pagination {
    // position: absolute;
    // bottom: 0;
    width: 96%;
    padding-bottom: 20px;
    // height: 80px;
  }

  .pagination {
    width: 100%;
    margin-top: 24px;
    text-align: center;
  }

  .empty-wrap {
    padding: 100px 0;
  }

  .empty-img {
    width: 338px;
    height: 218px;
  }

}
</style>